module.exports = __webpack_public_path__ + "img/9788949120928.bb409996.jpg";